import {
  LINK_CAROUSEL__CONTAINER_CLASS,
  LINK_CAROUSEL__HEADING_CLASS,
  maxBreakpoints,
  minBreakpoints,
} from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, colors } = theme;

export const wrapper = css`
  position: relative;

  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 8;
    `,
  )}
`;

export const relatedCategories = css`
  margin: ${pxToRem(spacing.xxxl)} 0;
  padding: ${pxToRem(spacing.sm)} 0;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-color: ${colors.neutralLight};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      .${LINK_CAROUSEL__HEADING_CLASS} {
        padding-left: ${pxToRem(spacing.md)};
      }
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      .${LINK_CAROUSEL__CONTAINER_CLASS} {
        max-width: 45rem;
        margin: 0 auto;
      }
    `,
  )}
`;
